/**
 * @deprecated Please use `toTestId` from `@panwds/react-utils`
 */
export function testIdGen(value) {
    return String(value).trim().replace(/\s+/g, '-').toLowerCase();
}
//# sourceMappingURL=testIdGen.js.map